import { useStore } from "zustand";
import { createStore } from "zustand/vanilla";

interface IAdminStore {
  isAdminDrawerOpen: boolean;
  setIsAdminDrawerOpen: (isOpen: boolean) => void;
}

/**
 * Create the Zustand store for managing the admin state.
 */
const AdminStore = createStore<IAdminStore>((set) => ({
  isAdminDrawerOpen: false,
  setIsAdminDrawerOpen: (isOpen) => {
    set(() => ({ isAdminDrawerOpen: isOpen }));
  },
}));

/**
 * A custom hook to access the company state.
 */
function useAdminStore(): IAdminStore;
function useAdminStore<Type>(selector: (state: IAdminStore) => Type): Type;
function useAdminStore<Type>(selector?: (state: IAdminStore) => Type) {
  return useStore(AdminStore, selector!);
}

export { useAdminStore };
